// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var ExtensionType_Enum;
(function (ExtensionType_Enum) {
    ExtensionType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    ExtensionType_Enum["OFFICE"] = "OFFICE";
    ExtensionType_Enum["USER"] = "USER";
    ExtensionType_Enum["VOICEMAIL"] = "VOICEMAIL";
})(ExtensionType_Enum || (ExtensionType_Enum = {}));
export var ExtensionType_Enum_index;
(function (ExtensionType_Enum_index) {
    ExtensionType_Enum_index[ExtensionType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ExtensionType_Enum_index[ExtensionType_Enum_index["OFFICE"] = 1] = "OFFICE";
    ExtensionType_Enum_index[ExtensionType_Enum_index["USER"] = 2] = "USER";
    ExtensionType_Enum_index[ExtensionType_Enum_index["VOICEMAIL"] = 3] = "VOICEMAIL";
})(ExtensionType_Enum_index || (ExtensionType_Enum_index = {}));
export var ExtensionNumberAvailability_Enum;
(function (ExtensionNumberAvailability_Enum) {
    ExtensionNumberAvailability_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    ExtensionNumberAvailability_Enum["AVAILABLE"] = "AVAILABLE";
    ExtensionNumberAvailability_Enum["IN_USE"] = "IN_USE";
    ExtensionNumberAvailability_Enum["RESERVED"] = "RESERVED";
})(ExtensionNumberAvailability_Enum || (ExtensionNumberAvailability_Enum = {}));
export var ExtensionNumberAvailability_Enum_index;
(function (ExtensionNumberAvailability_Enum_index) {
    ExtensionNumberAvailability_Enum_index[ExtensionNumberAvailability_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ExtensionNumberAvailability_Enum_index[ExtensionNumberAvailability_Enum_index["AVAILABLE"] = 1] = "AVAILABLE";
    ExtensionNumberAvailability_Enum_index[ExtensionNumberAvailability_Enum_index["IN_USE"] = 2] = "IN_USE";
    ExtensionNumberAvailability_Enum_index[ExtensionNumberAvailability_Enum_index["RESERVED"] = 3] = "RESERVED";
})(ExtensionNumberAvailability_Enum_index || (ExtensionNumberAvailability_Enum_index = {}));
export const ExtensionsAPI = {
    List(fn, req) {
        return fn(`/phone/extensions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Read(fn, req) {
        try {
            fm.validateUrlParam(req["extensionId"], "extensionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/extensions/${req["extensionId"]}?${fm.renderURLSearchParams(req, ["extensionId"])}`, { method: "GET" });
    },
    Renumber(fn, req) {
        try {
            fm.validateUrlParam(req["extensionId"], "extensionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/extensions/${req["extensionId"]}/number`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ValidateRenumber(fn, req) {
        try {
            fm.validateUrlParam(req["extensionId"], "extensionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/extensions/${req["extensionId"]}/validate-renumber`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
